import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { generateResetPasswordCode } from "../../../services/user";
import Button from "../Buttons/Button";
import InputField from "../Input/InputField";
import { customToast } from "../Toast";

const ForgotPasswordForm: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [username, setUsername] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const handleUsernameCheck = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();

    setLoading(true);

    try {
      const trimmedUsername = username.trim();

      if (!trimmedUsername) {
        setError("Username can not be empty");
      } else if (trimmedUsername) {
        await generateResetPasswordCode(trimmedUsername);

        //toast.success("Please check your email for the reset code");
        customToast(`Please check your email for the reset code`, "success");
        setUsername("");
      }
    } catch {
      //toast.error("Something bad happened, please try again");
      customToast(`Something bad happened, please try again.`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    setUsername(e.target.value);
  };

  const handleUsernameBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmedValue = e.target.value.trim();
    if (trimmedValue !== e.target.value) {
      setUsername(trimmedValue);
    }
  };

  return (
    <div className="font-outfit max-w-4xl flex justify-center md:mt-[40px]">
      <div className="md:shadow-lg w-[420px] md:bg-white rounded-[24px] md:p-[32px]">
        <h1 className="block font-semibold text-[32px] leading-[127%] ">
          Reset Password
        </h1>
        <p className="py-[16px] text-[18px] leading-[127%]">
          Enter your username, if it exists within our system, we shall send you
          a link to reset your password.
        </p>

        <form>
          <div className="relative flex flex-col space-y-[16px] text-[18px] pb-4">
            <InputField
              type="text"
              id="username"
              name="username"
              value={username}
              onChange={handleUsernameChange}
              onBlur={handleUsernameBlur}
              label="Email"
              placeholder="Username"
              autoComplete="username"
            />

            <AnimatePresence>
              {error && (
                <motion.p
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  //className="p-[12px] bg-[#E53A14] rounded-[8px] mb-[32px]"
                  className="first-letter:uppercase leading-[127%] font-normal text-[14px] text-[#E53A14]"
                >
                  {error}
                </motion.p>
              )}
            </AnimatePresence>
          </div>

          <Button
            iconVisibility="hide"
            ariaLabel="login"
            label="Send reset password link"
            loading={loading}
            handleClick={handleUsernameCheck}
          />
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
